export default __webpack_public_path__ + "static/media/instagram.a05a7fe7.svg";